export enum ContentDashboardType {
  EmployeeDashboard = "EMPLOYEE-DASHBOARD",
  ManagerDashboard = "MANAGER-DASHBOARD",
}

export const ContentDashboardTypeDisplayNames: Record<
  ContentDashboardType,
  string
> = {
  [ContentDashboardType.EmployeeDashboard]: "Employee Homepage",
  [ContentDashboardType.ManagerDashboard]: "Manager Homepage",
};

export default ContentDashboardType;
